<template>
  <div class="slideshow-progress">
    <span class="slideshow-progress__text">{{ progress }} / {{ total }}</span>
    <div class="slideshow-progress__bar">
      <div
        class="slideshow-progress__bar-fill"
        :style="{ width: `${progressPercentage}%` }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'slideshow-progress',
  computed: {
    ...mapState('teacher', {
      current: state => state.current.id,
    }),
    ...mapGetters('teacher', ['filteredGallery']),
    progress() {
      const index = this.filteredGallery.findIndex(
        item => item.id === this.current,
      );

      return index + 1;
    },
    progressPercentage() {
      return Math.floor((this.progress / this.total) * 100);
    },
    total() {
      return this.filteredGallery.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.slideshow-progress {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;

  &__text {
    display: inline-flex;
    margin-bottom: 1rem;
  }

  &__bar {
    display: flex;
    width: 100%;
    &-fill {
      height: 8px;
      background: color('background', 'light');
      transition: width 250ms linear;
    }
  }
}
</style>
